import "core-js/modules/es.array.includes.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Button, Chip, makeStyles, RED } from '@applyboard/ui-components';
import ApplyNowForConditionalEligibilityComponent from "../../ApplyNowForConditionalEligibilityComponent";
import { CefEventName } from "../../../../../EventTracker";
import { applyAction } from "../../../../CEF/Utilities/ResultsHelper";
var useStyles = makeStyles({
  chip: {
    '&:hover': {
      backgroundColor: RED[16]
    }
  }
});
var NOT_ELIGIBLE_BUTTON_TEXT = 'Not Eligible';
var NOT_ELIGIBLE_BUTTON_COLOR = 'negative';
var NotEligibleButton = function NotEligibleButton(_ref) {
  var onClick = _ref.onClick,
    useUpdatedButtonDesign = _ref.useUpdatedButtonDesign,
    variant = _ref.variant,
    fullWidth = _ref.fullWidth;
  var classes = useStyles();
  return useUpdatedButtonDesign ? /*#__PURE__*/React.createElement(Button, {
    fullWidth: fullWidth,
    onClick: onClick,
    variant: variant,
    color: NOT_ELIGIBLE_BUTTON_COLOR
  }, NOT_ELIGIBLE_BUTTON_TEXT) : /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    color: NOT_ELIGIBLE_BUTTON_COLOR,
    onClick: onClick
  }, NOT_ELIGIBLE_BUTTON_TEXT);
};
var NO_INTAKE_BUTTON_TEXT = 'No intake';
var NO_INTAKE_BUTTON_COLOR = 'warning';
var NoIntakeButton = function NoIntakeButton(_ref2) {
  var onClick = _ref2.onClick,
    useUpdatedButtonDesign = _ref2.useUpdatedButtonDesign,
    variant = _ref2.variant,
    fullWidth = _ref2.fullWidth;
  return useUpdatedButtonDesign ? /*#__PURE__*/React.createElement(Button, {
    fullWidth: fullWidth,
    variant: variant,
    onClick: onClick,
    color: NO_INTAKE_BUTTON_COLOR
  }, NO_INTAKE_BUTTON_TEXT) : /*#__PURE__*/React.createElement(Chip, {
    color: NO_INTAKE_BUTTON_COLOR,
    onClick: onClick,
    size: "regular"
  }, NO_INTAKE_BUTTON_TEXT);
};
var getFeatures = function getFeatures(_ref3) {
  var result = _ref3.result,
    openModalFn = _ref3.openModalFn,
    userId = _ref3.userId,
    programId = _ref3.programId,
    onTrack = _ref3.onTrack,
    variant = _ref3.variant,
    useUpdatedButtonDesign = _ref3.useUpdatedButtonDesign,
    fullWidth = _ref3.fullWidth;
  var eligibility = result.eligibility,
    intake_available = result.intake_available,
    recruitment_restricted = result.recruitment_restricted,
    searchData = result.searchData;
  var onApply = function onApply() {
    onTrack(CefEventName.ClickedApplyNow);
    applyAction(programId, userId, searchData);
  };
  var onTrackedClick = function onTrackedClick(eventName) {
    onTrack(eventName);
    openModalFn();
  };
  var button = /*#__PURE__*/React.createElement(Button, {
    fullWidth: fullWidth,
    variant: variant,
    onClick: function onClick() {
      return onTrackedClick(CefEventName.ClickedCheckEligibility);
    }
  }, useUpdatedButtonDesign ? 'Check Eligibility Now' : 'Check Eligibility');
  if (eligibility === 'ineligible') {
    button = /*#__PURE__*/React.createElement(NotEligibleButton, {
      onClick: function onClick() {
        return onTrackedClick(CefEventName.ClickedNotEligible);
      },
      useUpdatedButtonDesign: useUpdatedButtonDesign,
      variant: variant,
      fullWidth: fullWidth
    });
  } else if (intake_available && !recruitment_restricted) {
    if (eligibility === 'eligible') {
      button = /*#__PURE__*/React.createElement(Button, {
        fullWidth: fullWidth,
        variant: variant,
        onClick: onApply
      }, "Apply Now");
    } else if (eligibility === 'conditional') {
      button = /*#__PURE__*/React.createElement(ApplyNowForConditionalEligibilityComponent, {
        onApply: onApply,
        variant: variant,
        fullWidth: fullWidth
      });
    }
  } else if (['eligible', 'conditional'].includes(eligibility)) {
    button = /*#__PURE__*/React.createElement(NoIntakeButton, {
      onClick: function onClick() {
        return onTrackedClick(CefEventName.ClickedNoIntake);
      },
      variant: variant,
      fullWidth: fullWidth,
      useUpdatedButtonDesign: useUpdatedButtonDesign
    });
  }
  return {
    button: button
  };
};
export default getFeatures;